export default "__VITE_ASSET__Bzd58o$I__"